// web-staking-estimator-frontend/src/hooks/useServiceRequest.js
import { useState } from "react";
import { missingForEstimate } from "../utils/validation";

/**
 * Custom hook to manage service request information state
 * @returns {object} Hook utilities and state
 */
export function useServiceRequest() {
  const [requestInfo, setRequestInfo] = useState({
    svc_type: null,
    svc_phase: null,
    svc_volts: null,
    svc_amps: null,
    matched_service_id: null,
    svc_ohug: null,
  });

  /**
   * Check if service configuration is valid (has matched service and not blocked)
   */
  const serviceOk = !!requestInfo?.matched_service_id && !requestInfo?.blocked;

  /**
   * Get missing fields for estimate generation
   * @param {object} selectedPoint - The selected map point
   * @returns {string[]} Array of missing field descriptions
   */
  const getMissingForEstimate = (selectedPoint) => {
    return missingForEstimate(requestInfo, selectedPoint);
  };

  return {
    requestInfo,
    setRequestInfo,
    serviceOk,
    getMissingForEstimate,
  };
}
